<template>
    <div class="d-flex flex-fill">
        <div class="container py-3">
            <div class="row justify-content-center h-100">
                <div class="col-sm-12 col-lg-8 d-flex flex-column">
                    <div @click="saveLastCustomerDetails()" style="text-align: left;" class="mb-2 pointer">
                        <i class="fas mr-1 fa-save light"></i>
                        <small style="text-transform: initial;">Remember this info for future booking</small>
                    </div>
                    <client-form
                        class="flexGrow1 mb-3"
                        :disabled="disabled || isReservationReadOnly && reservation.status != -5"
                        :customer.sync="reservation.customer"
                        :bookingComponents="reservation.bookingComponents"
                        :transport="reservation.transport"
                        :reservation="reservation">
                    </client-form>

                    <client-transport :reservation="reservation" :disabled="disabled || isReservationReadOnly && reservation.status != -5"/>
               </div>

                <div class="col-sm-12 col-lg-4 mt-2 mt-lg-0">
                    <notes :reservation="reservation" :disabled="disabled || isReservationReadOnly && reservation.status != -5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations'

    import ClientForm from './ClientForm'
    import ClientTransport from './ClientTransport'
    import Notes from './Notes'

    export default {
        data() {
            return {}
        },
        props: {
            reservation: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ClientForm,
            ClientTransport,
            Notes,
        },
        mixins: [
            reservationsMixin
        ]
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// TabCustomer.vue?425188e6